import { Component, Input, OnInit } from '@angular/core';
import { ArrayUtils } from '../../../utils/array.utils';
import { ColumnDataTypeEnum } from '../../../enum/common/column-data-type.enum';

@Component({
  selector: 'app-table-footer-columns-generic',
  templateUrl: './table-footer-columns-generic.component.html',
  styleUrls: ['./table-footer-columns-generic.component.css']
})
export class TableFooterColumnsGenericComponent implements OnInit {

  @Input() col: any;
  @Input() dataList: any[];
  ArrayUtils = ArrayUtils;
  columnDataTypeEnum = ColumnDataTypeEnum;

  constructor() { }

  ngOnInit(): void {
  }

}
